import { render, staticRenderFns } from "./TabIndicator.vue?vue&type=template&id=58d9d52e&scoped=true&"
import script from "./TabIndicator.vue?vue&type=script&lang=js&"
export * from "./TabIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d9d52e",
  null
  
)

export default component.exports